import { MarketingHeroHeader } from "@/components/redesign/MarketingHeroHeader";
import { RedesignButton } from "@/components/redesign/RedesignButton";

interface NotFoundHeroProps {
  title: string;
  description: string;
  backHomeLabel: string;
  lang: string;
}

export default function NotFoundHero({
  title,
  description,
  backHomeLabel,
  lang,
}: Readonly<NotFoundHeroProps>) {
  return (
    <div>
      <MarketingHeroHeader title={title} subtitle={description} />
      <div className="mx-auto -mt-6 w-full max-w-6xl px-4 pb-10">
        <RedesignButton href={`/${lang}`}>&larr; {backHomeLabel}</RedesignButton>
      </div>
    </div>
  );
}
